import { gql } from '@apollo/client'

const DISH_QA_DATES_BY_QA_QUERY = gql`
  query dishQaDatesByQa($menuId: ID!, $qaIds: [ID!]!) {
    dishQaDatesByQa(menuId: $menuId, qaIds: $qaIds) {
      userId
      qadAt
    }
  }
`

export default DISH_QA_DATES_BY_QA_QUERY
